import {Component, Inject} from '@angular/core';
import {ProjectId} from '@webmate-web-core/shared/types/ids';
import {WebmateToolConfig} from '../modaltoolcontainer/modaltoolcontainer.service';
import {TOOL_CONTAINER_DATA} from '../modaltoolcontainer/modaltoolcontainer.component';

export type ManualWebsiteTestConfig = {
    url: string;
};

export class ManualWebsiteTestDialogToolConfig implements WebmateToolConfig {
    toolName = "Manual Website Test";
    scrollable = false;

    constructor(public projectId: ProjectId, public onConfirm: (config: ManualWebsiteTestConfig) => void) {}
}

@Component({
    selector: 'wm-manual-website-test-dialog',
    templateUrl: './manual-website-test-dialog.component.html',
    styleUrls: ['./manual-website-test-dialog.component.less']
})
export class ManualWebsiteTestDialogComponent {
    url = '';

    private static readonly URL_PATTERN = /^https?:\/\/.+/i;

    get isValidUrl(): boolean {
        return ManualWebsiteTestDialogComponent.URL_PATTERN.test(this.url);
    }

    constructor(@Inject(TOOL_CONTAINER_DATA) public data: ManualWebsiteTestDialogToolConfig) {}

    confirm() {
        this.data.onConfirm({url: this.url});
    }
}
